import type { ThinkingLevel } from "@kolisachint/hoocode-agent-core";

export const DEFAULT_THINKING_LEVEL: ThinkingLevel = "off";
